<template>
  <notifications class="relative z-60" position="top center" group="donationWidget" ></notifications>    
  <div class="px-10 flex flex-col h-full pb-10">
    <div class="space-y-3">
      <fieldset>
        <div class="flex items-center justify-center">
          <span class="font-medium">One-Time</span>
          <div class="relative px-3">
            <button 
              @click="
                toggleFrequency()
              "
              id="frequency-switch" 
              type="button" 
              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-300 ease-in-out focus:outline-none"
              v-bind:class="toggleClassObject"
              role="switch" 
              aria-checked="false"
            >
              <span class="sr-only">Use setting</span>
              <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
              <span 
                aria-hidden="true" 
                class="switcher pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-300 ease-in-out"
                v-bind:class="togglePositionClassObject" 
              ></span>
            </button>
          </div>
          <span class="font-medium">Monthly <i class="fa-solid fa-heart text-red-500"></i></span>
        </div>
      </fieldset>
      
      <fieldset>
        <div class="flex flex-col mt-3">
          <div><label class="block text-sm font-medium text-gray-700">How much would you like to donate?</label></div>
          <div class="switch-field grid gap-x-2 gap-y-2 grid-cols-3" v-show="isOnce">
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_1" value="5000" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_1">$50</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" checked="checked" class="hidden peer" type="radio" id="switch_2" value="7500" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_2"> $75 </label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_3" value="12500" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_3">$125</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_4" value="25000" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_4">$250</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_5" value="50000" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_5">$500</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" id="switch_6" type="radio" value="100000" name="donationAmount_oneTime" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_6">$1000</label></div>
          </div>
          <div class="switch-field grid gap-x-2 gap-y-2 grid-cols-3" v-show="isMonthly">
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_7" value="1500" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_7">$15</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" checked="checked" class="hidden peer" type="radio" id="switch_8" value="2500" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_8"> $25 </label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_9" value="5000" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_9">$50</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_10" value="7500" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_10">$75</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" type="radio" id="switch_11" value="10000" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_11">$100</label></div>
            <div><input v-model="selectedAmount" @change="updateDonationValue" class="hidden peer" id="switch_12" type="radio" value="15000" name="donationAmount_monthly" /><label class="transition-all ease-in-out duration-300 peer-checked:bg-blue-600 peer-checked:text-white cursor-pointer px-3 py-4 lg:px-6 lg:py-2 font-semibold border border-gray-200 hover:bg-gray-50 text-center text-black w-full block text-lg font-['Barlow_Condensed'] rounded-md" for="switch_12">$150</label></div>
          </div>
          <div class="my-3">
            <div class="relative mt-1 rounded-md shadow-sm">
              <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span class="text-black mt-1 font-['Barlow_Condensed'] font-medium">$</span>
              </div>
              <input 
                type="text" 
                v-model="enteredOtherAmount" 
                @input="updateDonationValueOther" 
                :class="{' border-red-500': errors.includes('other-amount') === true, 'border-gray-160': errors.includes('other-amount') === false }"
                name="other-amount" 
                id="alt_amount_input" 
                class="border block w-full border-gray-200 pl-7 pr-12 h-12 text-3xl font-medium text-blue-500 placeholder-blue-500 font-['Barlow_Condensed'] focus:border-gray-300 focus:outline-none focus:ring-0 rounded-md" 
                placeholder="75"
                autofocus
              >
              <div class="absolute inset-y-0 right-0 flex items-center">
                <label for="currency" class="sr-only">Currency</label>
                <select id="currency" name="currency" class="h-full border-transparent bg-transparent font-semibold py-0 pl-2 pr-7 text-gray-500 selection:text-black focus:border-transparent focus:ring-0 sm:text-sm">
                  <option>USD</option>
                  <option>CAD</option>
                  <option>EUR</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      
      <fieldset class="space-y-2 mb-3">
        <div class="relative flex items-start" v-if="this.donationWidgetState.occurrence == 'once'">
          <div class="flex h-5 items-center">
            <input 
              v-model="donationWidgetState.paidForTransactionFee"
              id="anonymous" 
              name="agreement"
              aria-describedby="processingFee"
              type="checkbox" 
              class="transition-all ease-in-out duration-300 h-4 w-4 border-gray-200 focus:ring-0 rounded-md"
            >
          </div>
          <div class="ml-3 text-sm">
            <label for="processingFee" class="text-black font-normal text-base">I would like to cover the processing fee of <span class="currency-code text-pink-500">$</span><span id="donation-fee" class="font-semibold text-pink-500">{{calculatedFee}}</span> so all of my donation goes to Side-Out Foundation</label>
          </div>
        </div>
        <div class="relative flex items-start" v-if="showMonthlyCheckbox">
          <div class="flex h-5 items-center">
            <input 
              v-model="monthlyAgreement"
              id="monthly-agreement" 
              name="monthly-agreement"
              type="checkbox" 
              class="transition-all ease-in-out duration-300 h-4 w-4 border-gray-200 focus:ring-0 rounded-md"
              :class="{ 'border-red-500': errors.includes('monthly-agreement') }"
            >
          </div>
          <div class="ml-3 text-sm">
            <label for="monthly-agreement" class="text-black font-normal text-base">I understand that this donation will be charged to my account every month on a recurring basis until I choose to cancel.</label>
          </div>
        </div>
        <div class="relative flex items-start">
          <div class="flex h-5 items-center">
            <input 
              @change="resetTributeOpenStatus"
              v-model="donationWidgetState.hasDedication" 
              id="tribute" 
              aria-describedby="tribute" 
              name="tribute" type="checkbox" 
              class="transition-all ease-in-out duration-300 h-4 w-4 border-gray-200 focus:ring-0 rounded-md"
            >
          </div>
          <div class="ml-3 text-sm">
            <label for="tribute" class="text-black font-normal text-base">Give in honor or memory of a loved one</label>
          </div>
        </div>
      </fieldset>
      
      <fieldset class="mt-auto space-y-0">
        <button
          @click.prevent="next"
          class="transition-all ease-in-out duration-300 bg-pink-500 hover:bg-pink-700 text-white uppercase py-2 px-4 w-full font-semibold mt-2 rounded-full"
        >
          Donate
        </button>
      </fieldset>
      
      <input type="hidden" id="donationFrequency" v-model="donationWidgetState.occurrence">
    </div>
  </div>
  
  <div id="tribute-swing" class="transition-all ease-in-out duration-300 w-full absolute h-full px-10 bg-white space-y-3 flex flex-col pb-5 z-10 justify-center" v-bind:class="tributeClassObject">
    <fieldset class="space-y-3">
      <p class="font-medium text-base mb-0 text-black">Personal Message</p>
      <p class="text-sm mb-0 text-gray-500">Write a personal message in honor or memory of a loved one</p>
      <div class="relative flex items-start">
        <div class="flex h-5 items-center">
          <input v-model="donationWidgetState.hasDedication" id="tribute-internal" aria-describedby="tribute-internal" name="tribute-internal" type="checkbox" class="transition-all ease-in-out duration-300 h-4 w-4 border-gray-200 focus:ring-0 rounded-md" checked="checked">
        </div>
        <div class="ml-3 text-sm">
          <label for="tribute-internal" class="text-black font-normal">Give in honor or memory of a loved one</label>
        </div>
      </div>
    </fieldset>
    <fieldset>
        <label for="inhonorormemory" class="block text-sm font-medium text-gray-700 sr-only">In honor of, or memory of</label>
        <select 
          v-model="tributeMode" 
          @change="updateTributeState"
          id="inhonorormemory" 
          name="inhonorormemory" 
          class="mt-1 block w-full border-gray-200 py-2 pl-3 pr-10 text-base sm:text-sm focus:ring-0 rounded-md"
        >
          <option value="honor" selected>In Honor Of</option>
          <option value="memory">In Memory Of</option>
        </select>
    </fieldset>
    <div id="in-honor" class="opacity-100 left-0 space-y-3 static">
      <fieldset>
        <label for="inhonorof" class="block text-sm font-medium text-gray-700">{{honoreeNameLabel}}</label>
        <div class="mt-1">
          <input
              class="block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border rounded-md"
              :class="{' border-red-500': errors.includes('dedication_honoree_name') === true, 'border-gray-160': errors.includes('dedication_honoree_name') === false }"
              v-model="donationWidgetState.honoreeName"
              id="dedication_honoree_name"
              name="dedication_honoree_name"
              placeholder=""
          >
        </div>
      </fieldset>
      <fieldset v-if="inHonorOfSelected">
        <label for="honoree-email" class="block text-sm font-medium text-gray-700">{{honoreeEmailLabel}}</label>
        <div class="mt-1">
          <input 
              class="block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border rounded-md"
              :class="{' border-red-500': errors.includes('dedication_honoree_email') === true, 'border-gray-160': errors.includes('dedication_honoree_email') === false }"
              v-model="this.donationWidgetState.honoreeEmail"
              id="dedication_honoree_email"
              name="dedication_honoree_email"
              placeholder="">
        </div>
      </fieldset>
      <fieldset>
        <label for="honoree-message" class="block text-sm font-medium text-gray-700">{{honoreeMessageLabel}}</label>
        <div class="mt-1">
          <textarea aria-required="true" aria-invalid="false" class="block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border rounded-md"
                    :class="{' border-red-500': errors.includes('message_to_honoree') === true, 'border-gray-160': errors.includes('message_to_honoree') === false }"
                    v-model="this.donationWidgetState.honoreeMessage"
                    name="message_to_honoree"
                    id=""
                    rows="3"
          ></textarea>
        </div>
      </fieldset>
    </div>
    <div id="in-memory" class="opacity-0 -left-[120%] space-y-3 absolute">
      <fieldset>
        <label for="inhonorof" class="block text-sm font-medium text-gray-700">In Memory Of</label>
        <div class="mt-1">
          <input type="text" name="memory-of" id="memory-of" class="block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-blue-200 focus:ring-0 rounded-md">
        </div>
      </fieldset>
      <fieldset>
        <label for="honoree-message" class="block text-sm font-medium text-gray-700">Message</label>
        <div class="mt-1">
          <textarea rows="4" name="memory-message" id="memory--message" class="block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-blue-200 focus:ring-0 rounded-md"></textarea>
        </div>
      </fieldset>
    </div>
    <fieldset>
      <p @click.prevent="saveTribute" id="save-tribute" class="text-black font-medium underline text-center cursor-pointer">Save</p>
    </fieldset>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  name: 'donation-form',

  data() {
    return {
      errors: [],
      showClassA: true,
      donationValue: '',
      tributeMode: 'honor',
      closeTribute: true,
      monthlyAgreement: false
    }
  },
  computed: {
    toggleClassObject() {
      return {
        'bg-green-500': this.donationWidgetState.occurrence == 'once',
        'bg-pink-600': this.donationWidgetState.occurrence == 'monthly',
      }
    },
    togglePositionClassObject() {
      return {
        'translate-x-0': this.donationWidgetState.occurrence == 'once',
        'translate-x-5': this.donationWidgetState.occurrence == 'monthly',
      }
    },
    donationWidgetState() {
      return this.$store.getters.donationWidget
    },
    selectedAmount: {
      get() {
        return this.donationWidgetState.amount
      },
      set(value) {
        this.$store.dispatch('updateAmount', value)
      },
    },
    otherAmountInView: {
      get() {
        return this.donationWidgetState.otherAmountInView
      },
      set(value) {
        this.$store.dispatch('updateOtherAmountInView', value)
      },
    },
    honoreeNameLabel() {
      if (this.donationWidgetState.inHonorOfSelection === 'memory') {
        return 'In memory of'
      }
      return `In honor of`
    },
    honoreeEmailLabel() {
      if (this.donationWidgetState.inHonorOfSelection === 'memory') {
        return `Recipient's email`
      }
      return `Honoree's email`
    },
    honoreeMessageLabel() {
      if (this.donationWidgetState.inHonorOfSelection === 'memory') {
        return `Message`
      }
      return `Message to honoree`
    },
    inHonorOfSelected() {
      return this.donationWidgetState.inHonorOfSelection !== 'memory'
    },
    calculatedAmount() {
      if (this.otherAmountInView == 'other') {
        if (!this.enteredOtherAmount) {
          return 0
        }
        return new BigNumber(this.enteredOtherAmount).times(100).toNumber()
      }
      return this.selectedAmount
    },
    enteredOtherAmount: {
      get() {
        return this.donationWidgetState.enteredOtherAmount
      },
      set(value) {
        this.$store.dispatch('updateEnteredOtherAmount', value)
      },
    },
    donationAmountForView() {
      return new BigNumber(this.calculatedAmount).dividedBy(100).toFormat(2)
    },
    isMonthly() {
      return this.donationWidgetState.occurrence == 'monthly'
    },
    isOnce() {
      return this.donationWidgetState.occurrence == 'once'
    },
    computedSelectedOption: function () {
        return (this.donationValue / 100).toString();
    },
    tributeClassObject() {
      return Object.assign({},
        { '-bottom-full': !this.donationWidgetState.hasDedication || this.closeTribute == true },
        { 'bottom-0': this.donationWidgetState.hasDedication && this.closeTribute != true },
        { 'opacity-0': !this.donationWidgetState.hasDedication || this.closeTribute == true },
        { 'opacity-100': this.donationWidgetState.hasDedication && this.closeTribute != true }
      )
    },
    calculatedFee() {
      const fixedFee = '30' // in cents
      const percentageFee = new BigNumber(0.022) // percentage
      const one = new BigNumber(1)
    
      const goal = new BigNumber(this.calculatedAmount)
      const calculatedCharge = goal.plus(fixedFee).dividedBy(one.minus(percentageFee))
      return BigNumber(calculatedCharge.minus(goal).dividedBy(100).toFormat(2))
    },
    calculatedTotal() {
      const amount = new BigNumber(this.donationWidgetState.amount)
    
      if (this.donationWidgetState.paidForTransactionFee) {
        return BigNumber(amount.plus(this.calculatedFee))
      }
      return amount
    },
    showMonthlyCheckbox() {
      return this.donationWidgetState.occurrence === 'monthly'
    },
  },
  methods: {
    updateTributeState(event) {
      this.donationWidgetState.inHonorOfSelection = event.target.value
    },
    updateDonationValueOther() {
      this.otherAmountInView = 'other'
      this.donationValue = this.enteredOtherAmount
      this.selectedAmount = this.enteredOtherAmount * 100
    },
    updateDonationValue() {
      this.donationValue = this.selectedAmount / 100
      this.enteredOtherAmount = this.donationValue
    },
    setMonthlyPopularAmount() {
      this.selectedAmount = 2500
      this.enteredOtherAmount = 25
    },
    setOncePopularAmount() {
      this.selectedAmount = 7500
      this.enteredOtherAmount = 75
    },
    setOtherAmountInView() {
      this.selectedAmount = ''
      this.otherAmountInView = 'other'
    },
    toggleFrequency() {
      this.donationWidgetState.occurrence = this.donationWidgetState.occurrence === 'once' ? 'monthly' : 'once'
      if ( this.donationWidgetState.occurrence == 'once' ) {
        this.setOncePopularAmount()
      } else {
        this.setMonthlyPopularAmount()
      }
    },
    saveTribute() {
      this.errors = []

      if (this.donationWidgetState.hasDedication) {
        if (!this.donationWidgetState.honoreeName) {
          this.errors.push('dedication_honoree_name')
        }
        
        if(this.donationWidgetState.inHonorOfSelection == 'honor') {
          if (!this.donationWidgetState.honoreeEmail || !this.validEmail()) {
            this.errors.push('dedication_honoree_email')
          }
        }
        
        if (!this.donationWidgetState.honoreeMessage) {
          this.errors.push('message_to_honoree')
        }
      }

      if( this.errors.length > 0) {
        this.donationWidgetState.steps.donation.isValid = false

        this.$notify({
          text: 'Please fix the validation errors',
          type: 'error',
          group: 'donationWidget',
        })
        return
      } else {
        this.closeTribute = true
      }
      
      return
    },
    
    resetTributeOpenStatus(event) {
      // Reset the closeTribute variable to false when the checkbox is engaged again -- this prevents the window from getting stuck in a closed state
      this.closeTribute = false
    },
    next() {
      this.errors = []
      
      if (this.otherAmountInView == 'other') {
        if ( !this.enteredOtherAmount) {
          this.errors.push('other-amount')
        }
        if (!this.validMoney(this.enteredOtherAmount)) {
          this.errors.push('other-amount')
        }
      } else {
        if (!this.validMoney(this.selectedAmount)) {
          this.errors.push('other-amount')
        }
      }
    
      if (this.showMonthlyCheckbox && !this.monthlyAgreement) {
        this.errors.push('monthly-agreement')
      }
    
      if( this.errors.length > 0) {
        this.donationWidgetState.steps.donation.isValid = false
    
        this.$notify({
          text: 'Please fix the validation errors',
          type: 'error',
          group: 'donationWidget',
        })
        return
      }
    
      this.$store.dispatch('updateDonationData', {
        hasDedication:  this.donationWidgetState.hasDedication,
        occurrence:  this.donationWidgetState.occurrence,
        otherAmountInView:  this.donationWidgetState.otherAmountInView,
        isAnonymous:  this.donationWidgetState.isAnonymous,
        inHonorOfSelection:  this.donationWidgetState.inHonorOfSelection,
        honoreeName:  this.donationWidgetState.honoreeName,
        honoreeEmail:  this.donationWidgetState.honoreeEmail,
        honoreeMessage:  this.donationWidgetState.honoreeMessage,
      })
    
      this.$store.dispatch('updateAmount', this.calculatedAmount)
    
      this.donationWidgetState.steps.donation.isInView = false
      this.donationWidgetState.steps.donation.isValid = true
      this.donationWidgetState.steps.payment.isInView = true
      
      this.donationWidgetState.enterFromDirection = 'translate-x-full'
      this.donationWidgetState.leaveToDirection = '-translate-x-full'
      
      return
    },
    validEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.donationWidgetState.honoreeEmail);
    },
    validMoney(money) {
      // https://stackoverflow.com/questions/2227370/currency-validation
      var re = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,9})?)$/;
      return re.test(money);
    }
  },
}
</script>

<style scoped>

</style>
